module.exports = __webpack_public_path__ + "img/Stock Analysis.b340db55.svg";